/** Shared pointer thresholds for Activity dock tab gestures. */
/** Raised from 6 → 12 so edge presses / slight jitter stay taps (dev-sync 86d26696). */
export const ACTIVITY_DOCK_DRAG_THRESHOLD_PX = 12;
